import { defineCustomElement } from '@tyler-components-web/core';
import { ProgressSpinnerComponent } from './progress-spinner';
export * from './progress-spinner-adapter';
export * from './progress-spinner-constants';
export * from './progress-spinner-foundation';
export * from './progress-spinner';
export function defineProgressSpinnerComponent() {
    defineCustomElement(ProgressSpinnerComponent);
}
